import * as React from 'react';
import autobind from 'autobind-decorator';

import { CardController } from 'src/app/shared/card.controller';
import { AutocompleteListDataService } from 'src/core/ui/autocomplete/autocomplete.data';
import { ClientListDataService } from '../../list/client-list.data';
import { ClientGeneralPartView } from './clientgeneral-part.view';

interface ClientGeneralPartControllerProps extends ComponentViewProps<ClientItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
}

export class ClientGeneralPartController extends React.Component<ClientGeneralPartControllerProps, any> {
	protected salutationDataService: AutocompleteListDataService;
	protected nationalityDataService: AutocompleteListDataService;
	protected clientDataService: ClientListDataService;

	constructor(props) {
		super(props);
		this.salutationDataService = AutocompleteListDataService.make();
		this.nationalityDataService = AutocompleteListDataService.make();
		this.clientDataService = ClientListDataService.make();
	}

	@autobind
	protected salutationQuery(q?: string) {
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.salutationDataService.addFilter('concept', 'eq', 'salutation');
			this.salutationDataService.addFilter('key', 'eq', 'salutation');
			this.salutationDataService.addSorting('value', 'asc', true);
			this.salutationDataService.searchKeywords = q;
			this.salutationDataService.pageSize = 100;
			return this.salutationDataService
				.load(query => query)
				.then(res => {
					this.props.setBusy(false);
					resolve({ items: res, totalCount: this.salutationDataService.totalPages });
				}).catch(err => {
					this.props.setBusy(false);
					reject(err);
				});
		});
	}

	@autobind
	protected nationalityQuery(q?: string) {
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.nationalityDataService.addFilter('concept', 'eq', 'nationality');
			this.nationalityDataService.addFilter('key', 'eq', 'nationality');
			this.nationalityDataService.addSorting('value', 'asc', true);
			this.nationalityDataService.searchKeywords = q;
			this.nationalityDataService.pageSize = 100;
			return this.nationalityDataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({ items: items, totalCount: this.nationalityDataService.totalPages });
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

	@autobind
	protected relatedCustomersQuery(q?: string) {
		return new Promise<QueryResult<ClientSummary>>((resolve, reject) => {
			this.clientDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.model.id > 0) {
				this.clientDataService.addFilter('id', 'ne', this.props.model.id);
				this.clientDataService.addFilter('type', 'eq', 0);
			}
			if (q != null && q != '') {
				this.clientDataService.addFilter('displayName', 'contains', q);
			}
			this.clientDataService.addSorting('displayName', 'asc', true);

			return this.clientDataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({ items: items, totalCount: this.clientDataService.totalPages });
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		const type = this.props.model.type;
		const model = this.props.model;
		return (
			<CardController
				title="General information"
				icon={type == 0 ? 'user' : 'copyright'}
				className="card-borderless"
				mode={this.props.mode}>
				<ClientGeneralPartView
					mode={this.props.mode}
					model={model}
					setBusy={this.props.setBusy}
					type={type == 0 ? 'Person' : 'Company'}
					salutationQuery={{ query: this.salutationQuery, dataSet: this.salutationDataService }}
					nationalityQuery={{ query: this.nationalityQuery, dataSet: this.nationalityDataService }}
					relatedCustomersRequest={{ query: this.relatedCustomersQuery, dataSet: this.clientDataService }}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/clientgeneral-part.controller.tsx